const styles = () => ({
  height: 'auto !important',
  zIndex: '2000',

  '.MuiAlert-message': {
    fontSize: '14px !important',

    p: {
      fontSize: '14px !important',
    },
  },

  '.MuiAlert-filled.MuiAlert-colorError': {
    background: '#DC143C',
  },

  '.MuiAlert-filled.MuiAlert-colorSuccess': {
    background: '#66CDAA',
  },

  '.MuiAlert-icon, .MuiAlert-action': {
    alignItems: 'center',
    paddingTop: 0,
    paddingBottom: 0,
  },
  a: {
    color: 'inherit',
    marginLeft: '4px',
  },
});

export default styles;
